export enum Logic {
    AND = 'AND',
    OR = 'OR',
}

export enum StructureItemValueType {
    FIELD = 'field',
    LOGIC = 'logic',
    GROUP = 'group',
}

export enum StructureItemType {
    TA_ALL = 'TA_ALL',
    TAC_All = 'TAC_All',
    DESC_All = 'DESC_All',
    IPC = 'IPC',
}